import * as React from 'react';
import { SVGProps } from 'react';
const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || '#569DE5'}
      d="M4.625 9h-1.25A.376.376 0 0 1 3 8.625v-1.25C3 7.169 3.169 7 3.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 0 1 4.625 9ZM8 8.625v-1.25A.376.376 0 0 0 7.625 7h-1.25A.376.376 0 0 0 6 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 8 8.625Zm3 0v-1.25A.376.376 0 0 0 10.625 7h-1.25A.376.376 0 0 0 9 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 11 8.625Zm-3 3v-1.25A.376.376 0 0 0 7.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 8 11.625Zm-3 0v-1.25A.376.376 0 0 0 4.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 5 11.625Zm6 0v-1.25a.376.376 0 0 0-.375-.375h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 0 0 .375-.375ZM14 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 14.5v-11A1.5 1.5 0 0 1 1.5 2H3V.375C3 .169 3.169 0 3.375 0h1.25C4.831 0 5 .169 5 .375V2h4V.375C9 .169 9.169 0 9.375 0h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0 1 14 3.5Zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 0 0 .188-.188Z"
    />
  </svg>
);
export default CalendarIcon;
